import Swal from 'sweetalert2';

const AdvancedAlertExamples = () => {
    // 이미지와 함께 하는 알림
    const handleImageAlert = () => {
        Swal.fire({
            title: '이미지 알림',
            text: '이미지가 포함된 알림입니다.',
            imageUrl: 'https://via.placeholder.com/300x200',
            imageWidth: 300,
            imageHeight: 200,
            imageAlt: '샘플 이미지',
            confirmButtonText: '확인',
        });
    };

    // HTML 내용이 포함된 알림
    const handleHTMLAlert = () => {
        Swal.fire({
            title: '<strong>HTML 제목</strong>',
            icon: 'info',
            html: `
        <div>
          <p>이것은 <b>HTML</b> 내용입니다.</p>
          <ul>
            <li>첫 번째 항목</li>
            <li>두 번째 항목</li>
            <li>세 번째 항목</li>
          </ul>
          <p><a href="https://example.com" target="_blank">외부 링크</a>도 가능합니다.</p>
        </div>
      `,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: '좋아요!',
            confirmButtonAriaLabel: '좋아요 버튼',
            cancelButtonText: '닫기',
            cancelButtonAriaLabel: '닫기 버튼',
        });
    };

    // 위치 선택 알림
    const handlePositionAlert = () => {
        Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: '우측 상단 알림',
            showConfirmButton: false,
            timer: 1500,
        });
    };

    // 자동 닫기 알림
    const handleTimerAlert = () => {
        let timerInterval: NodeJS.Timeout;
        Swal.fire({
            title: '자동 닫기 알림',
            html: '이 알림은 <b></b> 초 후에 자동으로 닫힙니다.',
            timer: 5000,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading();
                const timer = Swal.getPopup()?.querySelector('b');
                if (timer) {
                    timerInterval = setInterval(() => {
                        timer.textContent = `${Math.ceil((Swal.getTimerLeft() || 0) / 1000)}`;
                    }, 100);
                }
            },
            willClose: () => {
                clearInterval(timerInterval);
            },
        }).then(result => {
            if (result.dismiss === Swal.DismissReason.timer) {
                console.log('타이머에 의해 닫혔습니다.');
            }
        });
    };

    // AJAX 요청 시뮬레이션
    const handleAjaxAlert = () => {
        Swal.fire({
            title: '데이터를 제출하시겠습니까?',
            text: '이 작업은 되돌릴 수 없습니다!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '제출',
            cancelButtonText: '취소',
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: '제출 중...',
                    text: '잠시만 기다려주세요.',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                // 가짜 AJAX 요청 시뮬레이션
                setTimeout(() => {
                    Swal.fire({
                        title: '제출 완료!',
                        text: '데이터가 성공적으로 제출되었습니다.',
                        icon: 'success',
                        confirmButtonText: '확인',
                    });
                }, 2000);
            }
        });
    };

    // 입력 검증이 있는 알림
    const handleValidationAlert = () => {
        Swal.fire({
            title: '이메일 주소 입력',
            input: 'email',
            inputLabel: '이메일 주소를 입력하세요',
            inputPlaceholder: 'example@example.com',
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            inputValidator: value => {
                if (!value) {
                    return '이메일 주소를 입력해주세요!';
                }
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                    return '올바른 이메일 형식이 아닙니다!';
                }
                return null;
            },
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: '입력 완료',
                    text: `입력하신 이메일: ${result.value}`,
                    icon: 'success',
                });
            }
        });
    };

    // 파일 선택 알림
    const handleFileAlert = () => {
        Swal.fire({
            title: '파일 선택',
            input: 'file',
            inputAttributes: {
                accept: 'image/*',
                'aria-label': '이미지 파일 선택',
            },
            showCancelButton: true,
            confirmButtonText: '업로드',
            cancelButtonText: '취소',
        }).then(result => {
            if (result.isConfirmed && result.value) {
                const file = result.value as File;
                Swal.fire({
                    title: '파일 선택됨',
                    text: `선택된 파일: ${file.name}`,
                    icon: 'info',
                });
            }
        });
    };

    // 선택 옵션 알림
    const handleSelectAlert = () => {
        Swal.fire({
            title: '국가 선택',
            input: 'select',
            inputOptions: {
                KR: '대한민국',
                US: '미국',
                JP: '일본',
                CN: '중국',
                UK: '영국',
            },
            inputPlaceholder: '국가를 선택하세요',
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            inputValidator: value => {
                if (!value) {
                    return '국가를 선택해주세요!';
                }
                return null;
            },
        }).then(result => {
            if (result.isConfirmed) {
                const countries: { [key: string]: string } = {
                    KR: '대한민국',
                    US: '미국',
                    JP: '일본',
                    CN: '중국',
                    UK: '영국',
                };
                Swal.fire({
                    title: '선택 완료',
                    text: `선택하신 국가: ${countries[result.value]}`,
                    icon: 'success',
                });
            }
        });
    };

    // 라디오 버튼 알림
    const handleRadioAlert = () => {
        Swal.fire({
            title: '성별 선택',
            input: 'radio',
            inputOptions: {
                male: '남성',
                female: '여성',
                other: '기타',
            },
            inputValidator: value => {
                if (!value) {
                    return '성별을 선택해주세요!';
                }
                return null;
            },
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
        }).then(result => {
            if (result.isConfirmed) {
                const genders: { [key: string]: string } = {
                    male: '남성',
                    female: '여성',
                    other: '기타',
                };
                Swal.fire({
                    title: '선택 완료',
                    text: `선택하신 성별: ${genders[result.value]}`,
                    icon: 'success',
                });
            }
        });
    };

    // 체크박스 알림
    const handleCheckboxAlert = () => {
        Swal.fire({
            title: '약관 동의',
            input: 'checkbox',
            inputValue: 0,
            inputPlaceholder: '개인정보 처리방침에 동의합니다',
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            inputValidator: value => {
                if (!value) {
                    return '약관에 동의해주세요!';
                }
                return null;
            },
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: '동의 완료',
                    text: '약관에 동의하셨습니다.',
                    icon: 'success',
                });
            }
        });
    };

    // 범위 선택 알림
    const handleRangeAlert = () => {
        Swal.fire({
            title: '만족도 평가',
            input: 'range',
            inputLabel: '서비스 만족도 (1-10)',
            inputAttributes: {
                min: '1',
                max: '10',
                step: '1',
            },
            inputValue: 5,
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: '평가 완료',
                    text: `만족도 점수: ${result.value}점`,
                    icon: 'success',
                });
            }
        });
    };

    return (
        <div
            style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
            }}
        >
            <h2>고급 SweetAlert2 사용 예시</h2>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button onClick={handleImageAlert}>이미지 알림</button>
                <button onClick={handleHTMLAlert}>HTML 알림</button>
                <button onClick={handlePositionAlert}>위치 알림</button>
                <button onClick={handleTimerAlert}>자동 닫기</button>
            </div>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button onClick={handleAjaxAlert}>AJAX 시뮬레이션</button>
                <button onClick={handleValidationAlert}>입력 검증</button>
                <button onClick={handleFileAlert}>파일 선택</button>
                <button onClick={handleSelectAlert}>선택 옵션</button>
            </div>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button onClick={handleRadioAlert}>라디오 버튼</button>
                <button onClick={handleCheckboxAlert}>체크박스</button>
                <button onClick={handleRangeAlert}>범위 선택</button>
            </div>
        </div>
    );
};

export default AdvancedAlertExamples;
